export default __webpack_public_path__ + "static/media/Email.d04404d2.png";